var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"outlined":_vm.url!='',"flat":_vm.url==''}},[_c('div',{staticClass:"embed-frame",style:(_vm.style)},[_c('iframe',{attrs:{"src":_vm.url,"width":"800","height":"600","frameborder":"0","allowFullScreen":"true"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }